import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";

// ==============================|| ALL ROUTING RENDER ||============================== //

export default function AllRoutes() {
    return useRoutes([AuthenticationRoutes, MainRoutes]);
}
